const URL = 'https://iliad-wos.inesctec.pt'
  
export default {
  MAP_GOOGLE_KEY: 'AIzaSyB7DgboLb_ybkgObTqlSg0w_5Wh5UH_gXk',
  URL,
  API_URL: `${URL}/public`,
  banner: `https://www.ec-meloa.eu/img/banner/banner_3_imagem_1520698050.png`
}